import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nexus_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-retry transient edge/origin errors (Cloudflare 5xx, network blips) for
// idempotent GETs only — never retry writes, to avoid double charges/sends.
const TRANSIENT_STATUS = [502, 503, 504, 520, 521, 522, 523, 524];
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const status = error.response?.status;
    const method = (cfg.method || "get").toLowerCase();
    const transient = !error.response || TRANSIENT_STATUS.includes(status);
    if (transient && method === "get" && (cfg.__retryCount || 0) < 2) {
      cfg.__retryCount = (cfg.__retryCount || 0) + 1;
      await new Promise((res) => setTimeout(res, 400 * cfg.__retryCount));
      return api(cfg);
    }
    return Promise.reject(error);
  }
);

export function setToken(token) {
  if (token) localStorage.setItem("nexus_token", token);
  else localStorage.removeItem("nexus_token");
}

export function apiError(e) {
  const status = e?.response?.status;
  const d = e?.response?.data?.detail;
  // If the app returned a structured error (even on 4xx/5xx), always surface it.
  if (d != null) {
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
    if (d?.msg) return d.msg;
    return String(d);
  }
  // No structured body: edge/origin failure (Cloudflare 5xx HTML) or network blip.
  if (!e?.response || TRANSIENT_STATUS.includes(status) || (status && status >= 500)) {
    return "The service is briefly busy — please try again in a moment.";
  }
  return e?.message || "Something went wrong.";
}

export default api;
